import { UniversalFilterField } from '../../../../../helpers/filters/UniversalFilter';

export {
  UniversalFilterTypes,
  UniversalFilterTextModes
} from '../../../../../helpers/filters/UniversalFilter';

export type CompactIndexTableHeaderSortFilterCellFilterFieldName<
  FiltersType extends Record<string, any>
> = Extract<keyof FiltersType, string>;

export type CompactIndexTableHeaderSortFilterCellFilterField<FiltersType> =
  UniversalFilterField<FiltersType>;
